import { computed, DOCUMENT, inject, Service, signal } from '@angular/core';

@Service()
export class OverlayService {
    private readonly document = inject(DOCUMENT);
    private readonly stack = signal<string[]>([]);

    readonly active = computed(() => this.stack().length > 0);

    register(): string {
        const id = crypto.randomUUID();
        this.stack.update((s) => [...s, id]);
        this.document.body.classList.add('lock');
        return id;
    }

    unregister(id: string): void {
        this.stack.update((s) => s.filter((i) => i !== id));

        if (this.stack().length === 0) {
            this.document.body.classList.remove('lock');
        }
    }

    isTop(id: string): boolean {
        const s = this.stack();
        return s.length > 0 && s[s.length - 1] === id;
    }
}
